function getData(obj) {
  return obj.data;
}

export default getData;
